import {
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import userProfile from '../../../../assets/images/userProfile.svg';
import React, { useEffect, useState, MouseEvent } from 'react';
import { Pagination } from '../../../../components';
import { useNavigate } from 'react-router-dom';
import Popup from '../../../../components/Popup';
import { ReactComponent as SearchIcon } from '../../../../assets/images/Search.svg';
import useDebounce from '../../../../components/Debounce';
import { useSelector, useDispatch } from 'react-redux';
import FilterImage from '../../../../assets/images/Filter.svg';
import { useHook as ControllerHook } from './useHook';
import { closeBlackIcon } from '../../../../assets/images';
import { Unauthorized } from '../../../../components/index';
import { ErrorMessage } from '../../../../permissionErrorMessage/PermissionMessage';
interface Filter {
  model: string[];
}
interface Props {
  pagePermissionIDs: unknown;
}

const Controller: React.FC<Props> = ({ pagePermissionIDs }) => {
  const canCreateRoles =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('controllers::create');
  const canDeletePermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('controllers::delete');
  const canlistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('controllers::list');
  const canUpdatePermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('controllers::update');

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['controllers::list'] || ''}</li>
      </ul>
    </section>
  );
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteid, setDeleteid] = useState<string>('');
  const [search, setSearch] = useState<string>('');
  const debouncedSearch = useDebounce(search, 1000);
  const [modelAnchorEl, setModelAnchorEl] = useState<null | HTMLElement>(null);
  const [eventNameQuery, setEventNameQuery] = useState<string>('');
  const [filteredModel, setFilteredModel] = useState<any[]>([]);
  const [selectedData, setSelectedData] = useState<string[]>([]);
  const [filtermodelSelectData, setFilterModelSelectData] = useState<string[]>(
    [],
  );
  const {
    fetchGetControllerFilter,
    fetchAllControllerList,
    deleteController,
    fetchControllerList,
  } = ControllerHook();
  const [seeMoreIndex, setSeeMoreIndex] = useState<number>(2);
  const { controlersList, controllerFilters } = useSelector(
    (state: any) => state.controller,
  );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    getData(page, rowsPerPage, search);
  };
  const handleRowsPerPageChange = (value: number) => {
    getData(1, value, search);
    setRowsPerPage(value);
    setCurrentPage(1);
  };
  const getData = async (
    pagenumber?: number,
    row_perpage?: number,
    search: unknown = '',
    filters: Filter[] | undefined = [],
    sort: { orderBy: string; order: number } = {
      orderBy: 'updatedAt',
      order: -1,
    },
  ) => {
    const payload = {
      sort: sort,
      search: search,
      filters: {
        models:
          filtermodelSelectData?.length > 0 ? filtermodelSelectData : null,
      },
      limit: row_perpage ? row_perpage : rowsPerPage,
      offset: pagenumber
        ? (pagenumber - 1) * rowsPerPage
        : (currentPage - 1) * rowsPerPage,
    };
    if (canlistPermission) {
      await fetchControllerList(payload).then((res: any) => {
        const totalPage = res?.count
          ? Math.ceil(res?.count / (row_perpage ? row_perpage : rowsPerPage))
          : 1;
        setTotalPages(totalPage);
      });
    }
  };

  const handleDeleteController = async () => {
    setCurrentPage(1);
    await deleteController({ controllerID: deleteid });
    getData(1);
    setDeletePopup(false);
    getAllController();
  };

  const handleSearchChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const search = event.target.value;
    // Allow only letters, numbers, and spaces
    const regex = /^[a-zA-Z0-9 ]*$/;
    if (regex.test(search)) {
      setSearch(search);

      if (!search) {
        getData(currentPage, rowsPerPage, search);
      } else {
        setCurrentPage(1);
      }
    }
  };

  const getAllController = async () => {
    await fetchAllControllerList({});
  };
  useEffect(() => {
    getData();
    if (canlistPermission) {
      fetchGetControllerFilter();
      getAllController();
    }
  }, [canlistPermission]);

  useEffect(() => {
    setFilteredModel(controllerFilters);
  }, [controllerFilters]);

  useEffect(() => {
    getData(currentPage, rowsPerPage, search);
  }, [filtermodelSelectData]);

  useEffect(() => {
    if (debouncedSearch) {
      getData(1, rowsPerPage, search);
      setCurrentPage(1);
    }
  }, [debouncedSearch]);

  const handleRemoveFilter = (filterName: string) => {
    const removeData = filtermodelSelectData?.filter(
      (data) => data !== filterName,
    );
    setSelectedData(removeData);
    setFilterModelSelectData(removeData);
    setSeeMoreIndex(removeData?.length);
    setCurrentPage(1);
  };

  const handleModelNameSearchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value;
    setEventNameQuery(query);

    const filtered = controllerFilters?.filter((item: any) =>
      item?.toLowerCase()?.includes(query?.toLowerCase()),
    );
    setFilteredModel(filtered);
  };
  const handleSubmitFilter = () => {
    setSeeMoreIndex(selectedData?.length);
    setFilterModelSelectData(selectedData);
    setCurrentPage(1);
    handleModelClose();
  };

  const handleModelChange = (modelName: any): void => {
    if (modelName) {
      if (selectedData.includes(modelName)) {
        const updatedData = selectedData.filter(
          (item: any) => item !== modelName,
        );
        setSelectedData(updatedData);
      } else {
        const adddata = [...selectedData, modelName];
        const uniqueEventNames = [...new Set(adddata)];
        setSelectedData(uniqueEventNames);
      }
    } else {
      return;
    }
  };

  const handleModelClick = (event: MouseEvent<HTMLElement>): void => {
    setModelAnchorEl(event.currentTarget);
  };
  const handleModelClose = () => {
    setModelAnchorEl(null);
  };
  const modelOpen = Boolean(modelAnchorEl);
  const modelId = modelOpen ? 'simple-popover' : undefined;
  return (
    <>
      {!canlistPermission ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          {deletePopup && (
            <Popup
              open={deletePopup}
              btntext="delete"
              handleClose={() => {
                setDeletePopup(false);
              }}
              handleDelete={() => {
                handleDeleteController();
              }}
              page="controller"
            />
          )}
          {/* <div className="controller_header">
        {' '}
        <h4>Modify or finalize permissions here for this role.</h4>
      </div> */}
          <div className="controller_header flex-wrap flex-md-nowrap">
            <div>
              <div className="action-card">
                <Button
                  aria-describedby={modelId}
                  className={
                    filtermodelSelectData?.length > 0
                      ? 'action-card_btn filter_buttons-active'
                      : 'action-card_btn'
                  }
                  onClick={handleModelClick}
                >
                  <img src={FilterImage} alt="Map img" />
                  <h5>Select Model</h5>
                  {filtermodelSelectData?.length > 0 && (
                    <div className="filter_buttons-active-filtercount">
                      <p>{filtermodelSelectData?.length}</p>
                    </div>
                  )}
                </Button>
              </div>
              {filtermodelSelectData
                ?.slice(0, seeMoreIndex)
                .map((data, index) => (
                  <div key={index} className="filterlist">
                    <p>{data}</p>
                    <Button onClick={() => handleRemoveFilter(data)}>
                      <img src={closeBlackIcon} alt="Delete Icon" width={13} />
                    </Button>
                  </div>
                ))}
              {filtermodelSelectData?.length > 2 && seeMoreIndex === 2 && (
                <div className="see_more_data">
                  <Button
                    onClick={() =>
                      setSeeMoreIndex(filtermodelSelectData?.length)
                    }
                  >{`+${filtermodelSelectData?.length - 2} More`}</Button>
                </div>
              )}
              {filtermodelSelectData?.length > 2 && seeMoreIndex !== 2 && (
                <div className="see_more_data">
                  <Button onClick={() => setSeeMoreIndex(2)}>show less</Button>
                </div>
              )}
            </div>
            <div className="table-header-btn">
              <TextField
                variant="outlined"
                placeholder="Search"
                value={search}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: <SearchIcon />,
                }}
                className="search-input"
              />
              {canCreateRoles && (
                <Button
                  className="create-btn"
                  color="primary"
                  onClick={() => navigate('/hardware/controller/create')}
                >
                  Create Controller
                </Button>
              )}
            </div>
          </div>

          <TableContainer className="controller_table" component={Paper}>
            <Table>
              <TableHead className="controller_tableheader">
                <TableRow>
                  <TableCell className="controller_tableheader_name">
                    Names
                  </TableCell>
                  <TableCell className="controller_tableheader_model">
                    Model
                  </TableCell>
                  <TableCell className="controller_tableheader_icon"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {controlersList.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={2}>
                      <Typography variant="body1" align="left">
                        No Data found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  controlersList &&
                  controlersList.map((controller: any, index: number) => (
                    <TableRow key={index}>
                      <TableCell>
                        <div className="controller_management_name-data">
                          <img
                            src={
                              controller?.image
                                ? controller?.image
                                : userProfile
                            }
                            width={40}
                            alt="User Profile"
                          />{' '}
                          <p>{controller.controllerName}</p>
                        </div>
                      </TableCell>
                      <TableCell>
                        <p className="controller_management_model-data">
                          {controller.model}
                        </p>
                      </TableCell>

                      <TableCell>
                        <div className="form-action-btn">
                          {canUpdatePermission && (
                            <Button
                              className="btn-transparent border-0 img-background-form"
                              onClick={() =>
                                navigate(
                                  `/hardware/controller/edit/${controller.controllerName ? controller.controllerName : ' '}/${controller.controllerID}`,
                                )
                              }
                            >
                              <i className="edit-icon bi bi-pencil-square bi-lg"></i>
                            </Button>
                          )}
                          {canDeletePermission && (
                            <Button
                              className="btn-transparent border-0 img-background-form"
                              onClick={() => {
                                setDeleteid(
                                  controller.controllerID
                                    ? controller.controllerID
                                    : '',
                                );
                                setDeletePopup(true);
                              }}
                            >
                              <i className="delete-icon bi bi-trash3-fill bi-lg"></i>
                            </Button>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            rowsPerPageOptions={[5, 10, 20, 30]}
            currentPage={currentPage}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleRowsPerPageChange}
            totalPages={totalPages}
          />

          <Popover
            className="popover-audit"
            id={modelId}
            open={modelOpen}
            anchorEl={modelAnchorEl}
            onClose={handleModelClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <div className="user_name-popover">
              <div className="user_name-popover-search">
                <TextField
                  className="user_name-popover-search_input search-input"
                  variant="outlined"
                  placeholder="Search model names here"
                  fullWidth
                  InputProps={{
                    startAdornment: <SearchIcon className="search_icon" />,
                  }}
                  value={eventNameQuery}
                  onChange={handleModelNameSearchChange}
                />
              </div>
              <div className="event-popover">
                {filteredModel?.map((model: any, index: number) => {
                  return (
                    <div
                      key={index}
                      className={
                        selectedData.includes(model)
                          ? 'role-popover-checkbox role-popover-checkbox_active'
                          : 'role-popover-checkbox'
                      }
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectedData.includes(model)}
                            onChange={() => {
                              handleModelChange(model);
                            }}
                          />
                        }
                        label={model}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="select_dropdown-btn">
              <Button
                className="select_dropdown-cancel-btn"
                onClick={handleModelClose}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSubmitFilter}
                disabled={selectedData?.length > 0 ? false : true}
                className={
                  selectedData?.length > 0
                    ? 'select_dropdown-btn'
                    : 'select_dropdown_disable-btn'
                }
              >
                Apply
              </Button>
            </div>
          </Popover>
        </>
      )}
    </>
  );
};

export default Controller;
